import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from 'src/app/guard/can-deactivate.guard';

const routes:Routes = [
  {
    path: 'worker',
    redirectTo: 'worker/main',
    pathMatch: 'full'
  },
  {
    path: 'worker/sign-up',
    loadChildren: () => import('./sign-up/sign-up.module').then( m => m.SignUpPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/sign-up-day-labor',
    loadChildren: () => import('./sign-up-day-labor/sign-up-day-labor.module').then( m => m.SignUpDayLaborPageModule)
  },
  {
    path: 'worker/main',
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/mypage',
    loadChildren: () => import('./mypage/mypage.module').then( m => m.MypagePageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/tbm-notice',
    loadChildren: () => import('./tbm-notice/tbm-notice.module').then( m => m.TbmNoticePageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/tbm-safestudy',
    loadChildren: () => import('./tbm-safestudy/tbm-safestudy.module').then( m => m.TbmSafestudyPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/tbm-riskfactor',
    loadChildren: () => import('./tbm-riskfactor/tbm-riskfactor.module').then( m => m.TbmRiskfactorPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/qr-scan',
    loadChildren: () => import('./qr-scan/qr-scan.module').then( m => m.QrScanPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/nfc-scan',
    loadChildren: () => import('./nfc-scan/nfc-scan.module').then( m => m.NfcScanPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/my-work-list',
    loadChildren: () => import('./my-work-list/my-work-list.module').then( m => m.MyWorkListPageModule)
  },
  {
    path: 'worker/notice-tbm',
    loadChildren: () => import('./notice-tbm/notice-tbm.module').then( m => m.NoticeTbmPageModule)
  },
  {
    path: 'worker/notice-tbm-detail',
    loadChildren: () => import('./notice-tbm-detail/notice-tbm-detail.module').then( m => m.NoticeTbmDetailPageModule)
  },
  {
    path: 'worker/sign-up-re',
    loadChildren: () => import('./sign-up-re/sign-up-re.module').then( m => m.SignUpRePageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/notice-emergency',
    loadChildren: () => import('./notice-emergency/notice-emergency.module').then( m => m.NoticeEmergencyPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/continue-main',
    loadChildren: () => import('./continue-main/continue-main.module').then( m => m.ContinueMainPageModule),
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'worker/registor-day-labor',
    loadChildren: () => import('./registor-day-labor/registor-day-labor.module').then( m => m.RegistorDayLaborPageModule),
    canDeactivate: [CanDeactivateGuard]
  }
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ]
})
export class WorkerRoutingModule { }
